import * as util from "../../../common/m_base/util"
import { override } from 'core-decorators'

import {RewardJsToggleCloseBtnShow, VideoBridgeToggleBouncesOff} from "@api";
import {getUrlParams} from "@src/common/util";

import {
    getEndScreenInfo,
} from "../../../api/index";
import Webview from "../../component/native/visible/Webview"
import Slot from "../../component/template/Slot";
import Container from "../../component/Container"
import {getFilePathByRemoteUrl} from '@src/common/util'
import MultipleOfferTemplate from "../../component/template/MultipleOfferTemplate";
import SingleVideoRewardManager from '../../component/visible/SingleVideoRewardManager/SingleVideoRewardManager'
import App from "../../App";

/**
 * mintegral SDK 大模板
 */
export default class btChooseFirstDemo extends MultipleOfferTemplate {
    constructor(props = {}) {
        super(props)

        this.templateName = props.templateName || 'mtg_btChooseFirstDemo_template'

        this.currentOffer = this.campaignList[0]
    }

    show() {
        super.show()
        console.log('im show')
    }

    initComponents() {
        super.initComponents()

        this.campaignList.forEach(campaign=>{
            const subTpl = new Webview()
            let subTplURL = campaign && campaign.rv && campaign.rv.template_url

            Webview.getLoadCampaignParams(subTplURL, [campaign], this.unit.id, this.unit.setting)
            .then(loadParams=>{
                console.log('获取到load campaign参数：', loadParams)
                subTpl.load(loadParams)
            })

            campaign.getTemplate = ()=>{
                return subTpl
            }
        })

        App.onAdShow(async e => {
            // var VConsole = require('vconsole');
            // window.vConsole === undefined && (window.vConsole = new VConsole());

            // RV IV 弹窗 & 关闭按钮逻辑初始化
            let {campaignList, appSetting, unitSetting} = window.initData
            let currentCampaign = campaignList[0]
            let ad_type = currentCampaign.ad_type

            // init test video
            let videoWrap = document.createElement('div')
            let videoLog = document.createElement('div')
            videoLog.id = 'videoLog'
            let videoElement = document.createElement('video')
            videoElement.src = 'https://cdn-adn-https-new.rayjump.com/cdn-adn/vh/19/10/29/10/58/40b237c9176f47cc00de81389090243d.mp4'
            videoElement.preload = 'auto'
            videoElement.setAttribute('playsinline', '')
            videoElement.setAttribute('webkit-playsinline', '')
            videoElement.style.cssText += `position: absolute;top: 50%;right: 50%;width: 20vw;height:20vw,object-fit: contain;z-index: 999; transform: translate3d(-50%, -50%, 0);`
            videoWrap.appendChild(videoElement)
            videoWrap.appendChild(videoLog)
            document.querySelector('#app').appendChild(videoWrap)
            videoElement.addEventListener('timeupdate', e => {
                videoLog.insertAdjacentHTML("beforeend", `<div class="log-item">timeupdate：${videoElement.currentTime}</div>`)
            })
            videoElement.addEventListener('ended', e => {
                videoElement.style.cssText += 'width: 30vw;height:30vw,'
                console.log('================视频播放完成=================', videoElement, videoElement.currentTime, currentCampaign.video_length)
            })
            let videoElementPlayResult = await videoElement.play().catch(e => {
                console.error('播放视频时出现问题', e, videoElement)
            })
            console.log({videoElementPlayResult})
            // closeAd
            videoElement.addEventListener('click', () => {
                App.closeAd()
            })
            document.querySelector('#mtg_closeAd').addEventListener('click', () => {
                App.closeAd()
            })

            // init SingleVideoRewardManager
            SingleVideoRewardManager.init({
                ad_type,
                appSetting,
                unitSetting,
                videoElement,
                currentCampaign
            })
        })

    }

    bindPageEvent() {
        const offerBanner = document.querySelector('.offer-banner')
        console.log('offerBanner', offerBanner)
        if (offerBanner) {
            console.log('offerBanner addEventListener', offerBanner)
            offerBanner.addEventListener('click', (e) => {
                console.log('offerBanner click', e)
                const nextOffer = this.campaignList[this.campaignList.indexOf(this.currentOffer) + 1] || this.campaignList[0]

                console.log('nextOffer', nextOffer)
                const subTpl = nextOffer.getTemplate()
                console.log('subTpl', subTpl)
                // this.slotOut('slot_1', this.currentOffer.getTemplate())
                this.currentOffer.getTemplate().removeSelf()
                this.slotIn('slot_1', subTpl)
                console.log('subTpl ====')

                offerBanner.innerText = this.currentOffer.title

                this.currentOffer = nextOffer
            }, false)

        }
        const nextOffer = this.campaignList[this.campaignList.indexOf(this.currentOffer) + 1] || this.campaignList[0]
        offerBanner.innerText = nextOffer.title
        document.documentElement.addEventListener('click', (e) => {
            console.log('documentElement click', e)
        }, false)
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
        this.container.onAppend(event => {
            console.log('onAppend', event)
        })
        this.container.onAppendTo(event => {
            console.log('onAppendTo', event)
        })
        this.container.onBgColorChanged(event => {
            console.log('onBgColorChanged', event)
        })
        this.container.onLoad(event => {
            console.log('onWebviewLoad', event)
        })
        this.container.onClicked(event => {
            console.log('onClicked', event)
        })
    }

    /**
     * 初始化插槽
     */
    initSlots() {
        super.initSlots()
        // this.slotIn('slot_1', this.currentOffer.getTemplate())
        //this.slotInBelow('slot_1', this.currentOffer.getTemplate())
        //this.slotIn('slot_2', this.subTpl2)
        //this.slotInBelow('slot_2', this.subTpl2)
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.currentOffer.getTemplate() && this.currentOffer.getTemplate().destory()
        //this.subTpl2 && this.subTpl2.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish() {
        return Promise.all([
            super._isLoadFinish(),
            this.currentOffer.getTemplate().whenCampaignReady()
            //this.subTpl2.whenCampaignReady()
        ])
    }

}